<template>
  <p-product-detail-block
    data-test="reviews"
    :title="getTitle"
    :has-background-title="true"
    v-if="cooperativeReview && (cooperativeReview.upsides || cooperativeReview.tips)"
  >
    <div class="product-detail-block-review">
      <p-product-detail-block
        data-test="review-upsides"
        :title="i18n._('Les plus')"
        v-if="cooperativeReview.upsides"
        class="product-detail-block-review__column"
      >
        <template #icon>
          <span class="adn-icon adn-icon--category-pro" aria-hidden="true" />
        </template>
        <template #title>
          <span class="product-detail-block-review__column-title">{{ i18n._('Les plus') }}</span>
        </template>
        <div class="product-detail-block-review__column-content" data-test="adn-text-area">
          <adn-text-area :initial-value="cooperativeReview.upsides" :edition="false" />
        </div>
      </p-product-detail-block>
      <p-product-detail-block
        data-test="review-tips"
        :title="i18n._(`Information d'utilisation`)"
        v-if="cooperativeReview.tips"
        class="product-detail-block-review__column"
      >
        <template #icon>
          <span class="adn-icon adn-icon--category-recommendations" aria-hidden="true" />
        </template>
        <template #title>
          <span class="product-detail-block-review__column-title">{{ i18n._(`Information d'utilisation`) }}</span>
        </template>
        <div class="product-detail-block-review__column-content" data-test="adn-text-area">
          <adn-text-area :initial-value="cooperativeReview.tips" :edition="false" />
        </div>
      </p-product-detail-block>
    </div>
  </p-product-detail-block>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from 'vue'
import AdnTextArea from '@b2ag/design-system/src/components/AdnTextArea/AdnTextArea.vue'
import { i18n } from '@b2ag/locale'
import PProductDetailBlock from '../PProductDetailBlock/PProductDetailBlock.vue'
import { type CooperativeReview } from './typings'

export default defineComponent({
  name: 'PProductDetailBlockReview',
  props: {
    cooperativeReview: {
      type: Object as PropType<CooperativeReview>,
      default: () => ({}),
    },
    cooperativeName: {
      type: String,
      default: 'votre partenaire',
    },
    isPack: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PProductDetailBlock,
    AdnTextArea,
  },
  setup(props) {
    const getTitle = computed(() => {
      const computedCooperativeName = props.cooperativeName ? props.cooperativeName : 'votre partenaire'
      return `Le point de vue de ${computedCooperativeName}`
    })

    return {
      getTitle,
      i18n,
    }
  },
})
</script>

<style scoped lang="scss">
.product-detail-block-review {
  display: flex;
  flex-direction: column;
  padding: 0 var(--spacing-4);

  @media (min-width: $breakpoint-sm) {
    padding: var(--spacing-4) var(--spacing-4) 0 var(--spacing-4);
  }

  &__column {
    flex: 1;
    border: none;
    padding: 0;

    @media (min-width: $breakpoint-lg) {
      flex-direction: row;
      margin: 0;
    }

    &-title {
      text-transform: none;
      margin-left: 0.5rem;
    }

    &-content {
      white-space: pre-line;
    }
  }

  @media (min-width: $breakpoint-lg) {
    display: flex;
    flex-direction: row;
  }
}
</style>
